import styled from 'styled-components'
import { SelectMui } from 'src/components/SelectMui'
import TextFieldMui from 'src/components/TextFieldMui'

export const SelectForm = styled(SelectMui)`
    margin: 0 !important;
`

export const TextForm = styled(TextFieldMui)`
    margin: 0 !important;
`

export const Wrapper = styled.form`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    gap: 16px;
`
